import _indexOf from './index-of.js'

export default (a, list) => _indexOf(list, a, 0) >= 0
